// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"c4a8894c","548":"4865bdc3"}[chunkId] + ".chunk.js";
};